// eslint-disable-next-line @typescript-eslint/no-explicit-any -- меняем ключи
export function mapKeysDeep(object: Object, keyMap: Record<string, string>): any {
    if (typeof object !== 'object' || object === null) {
        return object; // Если это не объект или null, возвращаем значение как есть
    }

    // Определяем, является ли объект массивом или обычным объектом
    if (Array.isArray(object)) {
        return object.map((item) => mapKeysDeep(item, keyMap)); // Рекурсивно обрабатываем каждый элемент массива
    }

    return Object.fromEntries(
        Object.entries(object).map(([key, value]) => {
            const newKey = keyMap[key] || key; // Получаем новое имя ключа или оставляем старое
            const newValue = mapKeysDeep(value, keyMap); // Рекурсивно обрабатываем значение

            return [newKey, newValue];
        })
    );
}
